import $ from 'jquery';
import animateDivs from './so-animate';
// import masonry from 'masonry';
// var masonry = require('masonry')
import Masonry from 'masonry-layout'

let msnry

if ( $('.testimonial-feed').length ) {
  const grid = document.querySelector('.testimonial-feed')
  msnry = new Masonry(grid, {
    itemSelector: '.student',
    transitionDuration: 0,
    initLayout: false
  })
  msnry.once('layoutComplete', () => {
    grid.classList.add('load')
  })

  msnry.layout()
  // $('.testimonial-feed').masonry({
  //   itemSelector: '.student',
  //   columnWidth: 200
  // });
}
if ( $('.post-feed-header').length ) {
  $('.post-feed .row-item:nth-child(1), .post-feed .row-item:nth-child(2)').addClass('animated')
  let currentPage = 1
  $('.post-feed-header a').on('click', function(e) {
    e.preventDefault()
    currentPage = 1
    $('.post-feed-header a').removeClass('active')
    $(this).addClass('active')
    get_more_sifu_och_posts();
  })

  $('.more-posts').on('click', function(e) {
    currentPage++
    get_more_sifu_och_posts();
  })

  function get_more_sifu_och_posts () {
    const postType = $('.post-feed').data('post-type')
    const ajaxData = {
      'action': 'do_ajax',
      'fn' : 'get_feed_posts',
      'paged' : currentPage,
      'postType': postType
    }
    if ( postType === 'testimonial' ) {
      const noUseIds = []
      $('.student').each( student => {
        noUseIds.push($(student).data('member-id'))
      })
      ajaxData.ids = noUseIds
    }
    console.log(ajaxData)
    if ( $('.post-feed-header a.active').length ) {
      const postTerm = $('.post-feed-header a.active').data('term')
      if ( postTerm !== 'all' ) {
        ajaxData.term = postTerm;
      }
    }
    $.ajax({
      url: ajaxurl,
      method: 'post',
      type: 'json',
      data: ajaxData
    }).done(function (response) {
      if ( currentPage === 1 ) {
        var elems = msnry.getItemElements()
        msnry.remove( elems )
        $('.post-feed').empty()
      }
      if ( response ) {
        const data = JSON.parse(response)
        $(data.posts).each( function (index) {
          if ( $(this).is('div') ) {
            console.log(index)
            if (index === 0 || index === 2 ) {
              $(this).addClass('animated')
            }
            $('.post-feed').append(this)
            msnry.appended( $(this) );
          }
        })
        if (!data.more_posts) {
          $('.more-posts').hide();
        } else {
          $('.more-posts').show();
        }
        if ( $('.testimonial-feed').length ) {
          console.log('layout')
          msnry.reloadItems();
          msnry.layout();
        }
        animateDivs()
        addClickEventToMembers ()
      }
    })
  }
}

export default function addClickEventToMembers () {
  if ( $('.member, .testimonial, .student').length ) {
    $('.member.allow-popup, .testimonial, .student.allow-popup').off().on('click', function() {
      const instId = $(this).data('member-id')
      $('.so-popup').addClass('active')
      $('.so-popup-content').html('<span style="width: 100%; text-transform: uppercase; width: 100%; margin: 0 auto;" class="h2 text-uppercase text-center">Loading</span>')
      $.ajax({
        url: ajaxurl,
        method: 'post',
        type: 'json',
        data: {
          'action': 'do_ajax',
          'fn' : 'get_member',
          'member_id' : instId
        }
      }).done(function (response) {
        if ( response ) {
          $('.so-popup-content').html(response)
        }
      })
    })

    $('.close-popup').on('click', function() {
      $('.so-popup').removeClass('active')
    })

  }
}



// WEBPACK FOOTER //
// ./js/so-post-feed-scripts.js